import { render, staticRenderFns } from "./CreditosVenta.vue?vue&type=template&id=bd43b610"
import script from "./CreditosVenta.vue?vue&type=script&lang=js"
export * from "./CreditosVenta.vue?vue&type=script&lang=js"
import style0 from "./CreditosVenta.vue?vue&type=style&index=0&id=bd43b610&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports